import { render, staticRenderFns } from "./article6.vue?vue&type=template&id=420a42ca&scoped=true"
import script from "./article6.vue?vue&type=script&lang=js"
export * from "./article6.vue?vue&type=script&lang=js"
import style0 from "./article6.vue?vue&type=style&index=0&id=420a42ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a42ca",
  null
  
)

export default component.exports